<template>
  <iframe
    :src="`${url}/embed`"
    style="width: 100%; height: 100%; border: 0;"
    allowfullscreen
    scrolling="no"
  ></iframe>
</template>

<script>
export default {
  name: 'InstagramReel',

  props: {
    url: { type: String, required: true }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
